import EpdWizardVersionHistoryPage from './EpdWizardVersionHistoryPage';
import { withVersionHistoryGuard } from 'pages/v2/WithVersionHistoryGuard';

export default withVersionHistoryGuard(EpdWizardVersionHistoryPage);
